import Splide from '@splidejs/splide';
import {createXHR} from './utils';
import {startLoading, finishLoading} from './loading';

let courses = [];
let options = null;
const defaultTab = 'Trending';

const init = async () => {
  const coursesDataEl = document.getElementById('courses-data');
  // console.log('here 0');
  if (!coursesDataEl) {
    return;
  }
  courses = JSON.parse(coursesDataEl.innerHTML);
  // console.log('here 1');
  if (courses === null) return;
  // console.log('here 2');

  options = {
    splideElement: document.querySelector('#recommendations-splide'),
    splideInstance: null,
    content: [],
    tabsContainer: document.getElementById('recommendations-tabs-container'),
    cardsContainer: document.getElementById('recommendations-cards-container'),
    activeTabIndex: 0,
  };

  const exploreBtn = document.getElementById('c-recommendations__explore-btn');
  const viewMoreBtn = document.getElementById('c-recommendations__view-more-btn');

  if (exploreBtn === null || viewMoreBtn === null) {
    return;
  }

  exploreBtn.addEventListener('click', handleExploreClick);
  viewMoreBtn.addEventListener('click', handleViewMoreClick);

  startLoading(null, options.tabsContainer, true);
  getRecommendedCourses().then((resp) => {
    const respArr = Array.from(resp);

    if (respArr.length === 0) {
      finishLoading(null, options.tabsContainer);
      document.getElementById('c-recommendations').style.display = 'none';
      return;
    }

    options.content = respArr;
    options.content.forEach((elem, index) => {
      if (elem.name === defaultTab) {
        options.activeTabIndex = index;
      }
    });

    finishLoading(null, options.tabsContainer);
    renderRelatedContent(options);
  });
};

const getRecommendedCourses = () => new Promise((resolve, reject) => {
  const xhr = createXHR({
    method: 'GET',
    endpoint: `/api/v2/course/recommended-courses`,
  });

  xhr.onload = () => {
    switch (xhr.status) {
      case 200:
        resolve(JSON.parse(xhr.response));
        break;
      default:
        reject('[RECOMMENDED COURSES ERROR]: ' + xhr.status);
        break;
    }
  };
});

const renderRelatedContent = (options) => {
  const tabsContent = options.content.reduce((acc, tab, index) => {
    const tabName = tab.name;
    const svgIcon = (tabName === defaultTab ? 'icon-star' : tabName.replace(/ /g, '-').toLowerCase());

    const tabTemplate = `<div id="${index}-recommendations-tab" class="recommendations-tab ${index === options.activeTabIndex ? 'active' : ''}"><img class="recommendations-tab__icon" src="/assets/svg/instruments/${svgIcon}${index === options.activeTabIndex ? '-red' : ''}.svg" alt="" width="20" height="20"><span class="recommendations-tab__name">${tabName || 'Unknown Tab'}</span></div>`;
    return acc + tabTemplate;
  }, '');
  options.tabsContainer.innerHTML = tabsContent;

  const cardsContent = options.content[options.activeTabIndex].ids.reduce((acc, id) => {
    return acc + getCardTemplate(id);
  }, '');
  options.cardsContainer.innerHTML = cardsContent;

  options.tabsContainer.addEventListener('click', handleTabClick);
  options.cardsContainer.childNodes.forEach((card) => {
    card.addEventListener('click', handleCardClick);
  });


  options.splideInstance = new Splide(options.splideElement, {
    type: 'slide',
    perPage: 6,
    gap: '2rem',
    arrows: false,
    breakpoints: {
      2500: {
        perPage: 5,
      },
      1440: {
        perPage: 4,
      },
      1200: {
        perPage: 3,
      },
      1024: {
        perPage: 2,
      },
      768: {
        perPage: 1,
      },
      641: {
        perPage: 1,
      },
    },
  });
  options.splideInstance.mount();
};

const updateRelatedContent = (options) => {
  options.tabsContainer.childNodes.forEach((tab) => {
    if (tab.id.split('-')[0] === options.activeTabIndex) {
      if (tab.classList.contains('active')) {
        return;
      }

      const iconEl = tab.querySelector('img');
      const iconPath = iconEl.getAttribute('src');
      const startPath = iconPath.split('.svg')[0];
      const newPath = `${startPath}-red.svg`;
      iconEl.setAttribute('src', newPath);

      tab.classList.add('active');
    } else {
      const iconEl = tab.querySelector('img');
      const iconPath = iconEl.getAttribute('src');
      const newPath = iconPath.replace(/-red/g, '');
      iconEl.setAttribute('src', newPath);

      tab.classList.remove('active');
    }
  });

  options.splideInstance.destroy();

  const cardsContent = options.content[options.activeTabIndex].ids.reduce((acc, id) => {
    return acc + getCardTemplate(id);
  }, '');
  options.cardsContainer.innerHTML = cardsContent;
  options.cardsContainer.childNodes.forEach((card) => {
    card.addEventListener('click', handleCardClick);
  });

  options.splideInstance.mount();
};

const getCourseById = (id) => {
  const course = courses.filter((course) => course.id == id)[0];
  return course;
};

const getCardTemplate = (id) => {
  const course = getCourseById(id);
  if (!course) {
    return '';
  };
  const cardTemplate = `<div class="splide__slide recommendations-course-card" data-slug="${course.blob.slug}">
                                <div class="cover" style="background-image: url('${course.image_url}');"></div>
                                <div class="title">${course.title}</div>
                                <div class="guru">with <a href="/gurus/${course.blob.artist.slug}/" class="guru-url">${course.blob.artist.display_name}</a></div>
                                <div class="lessons">${course.blob.length} lessons</div>
                            </div>`;
  return cardTemplate;
};

const handleTabClick = (event) => {
  if (event.target.className !== 'recommendations-tabs-container' && event.target.className.trim().startsWith('recommendations-tab')) {
    options.activeTabIndex = findTabId(event.target).split('-')[0];
    updateRelatedContent(options);
  }
};

const findTabId = (eventTarget) => {
  if (eventTarget.id.endsWith('recommendations-tab')) {
    return eventTarget.id;
  }

  return findTabId(eventTarget.parentElement);
};

const handleCardClick = (event) => {
  window.location.assign(`/courses/${event.currentTarget.dataset.slug}/`);
};

const handleExploreClick = () => {
  window.location.assign('/courses');
};

const handleViewMoreClick = () => {
  const activeFilter = options.content[options.activeTabIndex].name;

  if (activeFilter === 'Trending') {
    window.location.assign(`/courses/?query=&type=Trending`);
  } else {
    window.location.assign(`/courses/?query=&instrument=${activeFilter}`);
  }
};

export default {init};
